import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-15f1c175"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "contact-form" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", { class: "contact-form__heading" }, "برای ما بنویسید:", -1))
const _hoisted_3 = { class: "row" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-12 col-lg-6" }, null, -1))
const _hoisted_5 = { class: "col-12 col-lg-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_alert = _resolveComponent("alert")!
  const _component_form_input = _resolveComponent("form-input")!
  const _component_form_textarea = _resolveComponent("form-textarea")!
  const _component_form_button = _resolveComponent("form-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.alert)
      ? (_openBlock(), _createBlock(_component_alert, {
          key: 0,
          onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.alert = undefined)),
          variant: _ctx.alert.variant,
          title: _ctx.alert.msg
        }, null, 8, ["variant", "title"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("form", {
        onSubmit: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)))
      }, [
        _createVNode(_component_form_input, {
          modelValue: _ctx.name,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.name) = $event)),
          label: "نام و نام خانوادگی",
          "error-message": _ctx.errors.name,
          error: (_ctx.meta.dirty && Boolean(_ctx.errors.name)) || Boolean(_ctx.errors.name),
          class: _normalizeClass([
          (_ctx.meta.dirty && Boolean(_ctx.errors.name)) || Boolean(_ctx.errors.name)
            ? 'mb-5'
            : 'mb-4',
        ]),
          "bg-color": _ctx.breakpoints.isDesktop ? '#f5f7f9' : '',
          "border-color": _ctx.breakpoints.isDesktop ? '#b1b1b1' : '',
          color: _ctx.breakpoints.isDesktop ? '#0c1229' : ''
        }, null, 8, ["modelValue", "error-message", "error", "class", "bg-color", "border-color", "color"]),
        _createVNode(_component_form_input, {
          modelValue: _ctx.mobile,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.mobile) = $event)),
          label: "شماره همراه",
          type: "tel",
          "error-message": _ctx.errors.mobile,
          error: 
          (_ctx.meta.dirty && Boolean(_ctx.errors.mobile)) || Boolean(_ctx.errors.mobile)
        ,
          class: _normalizeClass([
          (_ctx.meta.dirty && Boolean(_ctx.errors.mobile)) || Boolean(_ctx.errors.mobile)
            ? 'mb-5'
            : 'mb-4',
        ]),
          maxlength: 11,
          "bg-color": _ctx.breakpoints.isDesktop ? '#f5f7f9' : '',
          "border-color": _ctx.breakpoints.isDesktop ? '#b1b1b1' : '',
          color: _ctx.breakpoints.isDesktop ? '#0c1229' : ''
        }, null, 8, ["modelValue", "error-message", "error", "class", "bg-color", "border-color", "color"]),
        _createVNode(_component_form_textarea, {
          modelValue: _ctx.msg,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.msg) = $event)),
          label: "متن پیام",
          "error-message": _ctx.errors.msg,
          error: (_ctx.meta.dirty && Boolean(_ctx.errors.msg)) || Boolean(_ctx.errors.msg),
          class: _normalizeClass([
          (_ctx.meta.dirty && Boolean(_ctx.errors.msg)) || Boolean(_ctx.errors.msg)
            ? 'mb-5'
            : 'mb-4',
        ]),
          "bg-color": _ctx.breakpoints.isDesktop ? '#f5f7f9' : '',
          "border-color": _ctx.breakpoints.isDesktop ? '#b1b1b1' : '',
          color: _ctx.breakpoints.isDesktop ? '#0c1229' : '',
          rows: "4"
        }, null, 8, ["modelValue", "error-message", "error", "class", "bg-color", "border-color", "color"]),
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_form_button, {
              class: "contact-form__button",
              type: "submit",
              loading: _ctx.loading,
              "full-width": "",
              label: "ارسال پیام"
            }, null, 8, ["loading"])
          ])
        ])
      ], 32)
    ])
  ], 64))
}